interface Result {
  valid: boolean;
  message?: string;
}

export default ({ valid, message }: Result): Result => ({
  valid,
  message,
});
